import { apiGet, apiPost, apiDelete } from '@/app/api/core/http';
import { FAVORITES_PATHS } from './paths';

// All favorite resources share the same CRUD shape, only the base url differs
const makeFavoriteResource = (url) => ({
  getList: (params) => apiGet(url, { params }),
  getItem: (id) => apiGet(`${url}/${id}`),
  createItem: (data) => apiPost(url, { data }),
  deleteItem: (id) => apiDelete(`${url}/${id}`),
});

export const favoritesApiAdapter = {
  favoriteFeatureOptions: makeFavoriteResource(FAVORITES_PATHS.featureOptions),
  favoriteUserCountries: makeFavoriteResource(FAVORITES_PATHS.countries),
  favoriteUserTypes: makeFavoriteResource(FAVORITES_PATHS.types),
  favoriteUserNiceClasses: makeFavoriteResource(FAVORITES_PATHS.niceClasses),
};
